import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenModel } from '../models/candidateprofile-genmodel';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class DynamicformsService {
  baseUrl: string = environment.createCandidateUrl;
  constructor(private http: HttpClient) {}

  getCreateGen(companyHiringTypeId): Observable<GenModel> {
    return this.http.get<GenModel>(
      this.baseUrl +
        `getReferGenModelStructure?screenName=ExCreateCandidate&companyHiringTypeId=${companyHiringTypeId}`,
    );
  }

  // fake api call
  getAPIData() {
    return {
      name: 'POC',
      id: 1,
      candidateDetails: [
        {
          order: 1,
          type: 0,
          name: 'request title',
          displayName: 'Request Title',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 2,
          type: 0,
          name: 'recruiterId',
          displayName: 'Recruiter ID',
          button: 'button mat-button',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 3,
          type: 0,
          name: 'hiring manager',
          displayName: 'Hiring Manager(Optional)',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 7,
          type: 11,
          name: 'Requisition Year',
          displayName: 'Requisition Year',
          inputType: 'input_type',
          value: null,
          options: [
            {
              key: 0,
              value: '2019',
              selected: false,
            },
            {
              key: 1,
              value: '2018',
              selected: false,
            },
            {
              key: 2,
              value: '2017',
              selected: false,
            },
            {
              key: 3,
              value: '2016',
              selected: false,
            },
          ],
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 8,
          type: 11,
          name: 'quarter',
          displayName: 'Quarter',
          inputType: 'input_type',
          value: null,
          options: [
            {
              key: 1,
              value: 'Q1',
              selected: false,
            },
            {
              key: 2,
              value: 'Q2',
              selected: false,
            },
            {
              key: 3,
              value: 'Q3',
              selected: false,
            },
            {
              key: 4,
              value: 'Q4',
              selected: false,
            },
          ],
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 9,
          type: 0,
          name: 'indent no',
          displayName: 'Indent No.(Optional)',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 10,
          type: 0,
          name: 'functional area',
          displayName: 'Functional Area(Optional)',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 11,
          type: 0,
          name: 'location',
          displayName: 'Location',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 12,
          type: 11,
          name: 'establishment type',
          displayName: 'Establishment type',
          inputType: 'input_type',
          value: null,
          options: [
            {
              key: 1,
              value: 'Sez',
              selected: false,
            },
            {
              key: 2,
              value: 'Stp',
              selected: false,
            },
          ],
          placeHolder: 'placeholder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 13,
          type: 0,
          name: 'experience',
          displayName: 'Years of experience',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 14,
          type: 11,
          name: 'hiring Type',
          displayName: 'Hiring Type',
          inputType: 'input_type',
          value: null,
          options: [
            {
              key: 1,
              value: 'Fresher',
              selected: false,
            },
            {
              key: 2,
              value: 'Lateral',
              selected: false,
            },
          ],
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 15,
          type: 11,
          name: 'Digital Offering',
          displayName: 'Digital Offering',
          inputType: 'input_type',
          value: null,
          options: [
            {
              key: 0,
              value: 'D01',
              selected: false,
            },
            {
              key: 1,
              value: 'D02',
              selected: false,
            },
            {
              key: 2,
              value: 'D03',
              selected: false,
            },
          ],
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 16,
          type: 11,
          name: 'Digital Tag',
          displayName: 'Digital Tag',
          inputType: 'input_type',
          value: null,
          options: [
            {
              key: 0,
              value: 'AI automation',
              selected: false,
            },
            {
              key: 1,
              value: 'Full Stack',
              selected: false,
            },
            {
              key: 2,
              value: 'Angular',
              selected: false,
            },
          ],
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 17,
          type: 0,
          name: 'unit',
          displayName: 'Unit',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 18,
          type: 0,
          name: 'designation',
          displayName: 'Designation',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 19,
          type: 0,
          name: 'no of position',
          displayName: 'No. of position',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 20,
          type: 0,
          name: 'role',
          displayName: 'Role',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 21,
          type: 0,
          name: 'job level',
          displayName: 'Job level',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 22,
          type: 0,
          name: 'job sublevel',
          displayName: 'Job Sublevel',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 4,
          type: 15,
          name: 'Test Date',
          displayName: 'Date of Test',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 5,
          type: 15,
          name: 'interview date',
          displayName: 'Date of interview',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
        {
          order: 6,
          type: 15,
          name: 'close Date',
          displayName: 'Requisition close date',
          inputType: 'input_type',
          value: null,
          options: null,
          placeHolder: 'place_holder',
          isdependant: true,
          dependantTo: 'dependant_To',
          dependantAction: 'dependantAction',
        },
      ],
    };
  }
}
